'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _class, _temp;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _tooltip = require('./tooltip');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var CustomTolltip = (_temp = _class = function (_Component) {
  _inherits(CustomTolltip, _Component);
  function CustomTolltip() {
    _classCallCheck(this, CustomTolltip);
    var _this = _possibleConstructorReturn(this, (CustomTolltip.__proto__ || Object.getPrototypeOf(CustomTolltip)).call(this));
    _this.state = {
      tooltipOpen: false,
      position: 'right',
      innerstyle: {}
    };
    _this.toggle = function () {
      _this.setState({
        tooltipOpen: !_this.state.tooltipOpen
      });
    };
    _this.tip = _react2.default.createRef();
    return _this;
  }
  _createClass(CustomTolltip, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', null, this.props.children, _react2.default.createElement(_tooltip.TooltipContainer, {
        placement: this.props.position,
        isOpen: this.state.tooltipOpen,
        target: this.props.target,
        toggle: this.toggle,
        customstyle: this.props.customstyle,
        innerstyle: this.props.innerstyle,
        borderRule: this.arrowColor
      }, this.props.message));
    }
  }, {
    key: 'arrowColor',
    get: function get() {
      var position = this.props.position;
      if (position.search(/left/g) > -1) {
        return 'border-left-color';
      }
      if (position.search(/top/g) > -1) {
        return 'border-top-color';
      }
      if (position.search(/bottom/g) > -1) {
        return 'border-bottom-color';
      }
      return 'border-right-color';
    }
  }]);
  return CustomTolltip;
}(_react.Component), _class.defaultProps = {
  target: 'defaultTarget',
  customstyle: {}
}, _temp);
exports.default = CustomTolltip;